import {
  LegalWrapper,
  LegalWrapperProps,
  LegalWrapperData,
  LegalWrapperOptions,
} from "./legal-wrapper";
import { ComponentInterfaceBaseClass } from "@att-bit/duc.utils-ts.types";
import React from "react";

export interface LegalWrapperRuntimeProps {
  onClick?: () => void;
}

export class LegalWrapperInterface
  extends ComponentInterfaceBaseClass
  implements LegalWrapperProps
{
  key;
  data: LegalWrapperData;
  options: LegalWrapperOptions;
  margin;
  static initWithSanity(key, feed) {
    const t = new LegalWrapperInterface();
    const config = feed.configs || {};
    t.key = key;
    t.data = {
      legalText: feed.legalAEMPath?.legalShortPath?.master?.legalText || null,
      legalLinkText:
        feed.legalAEMPath?.legalShortPath?.master?.shortLegalLinkLabel || null,
      legalLink: feed.legalAEMPath?.legalModalPath
        ? feed.legalAEMPath.legalModalPath[0]
        : null,
      legalModalTitle: feed.legalAEMPath?.legalModalTitle || null,
      legalLongText:
        feed.legalAEMPath?.legalLongPath?.[0]?.master?.legalText || null,
      legalModalSize: feed.legalModalSize || 'MEDIUM',
      /*
            to be added when feed is updated with links in legal.
            legalModalSize?: string;
            linkColor?:string*/
      linkAnalyticsData: feed.linkAnalyticsData,
      onModalClose: feed.onModalClose,
      modalLoadAnalyticsData: feed.modalLoadAnalyticsData,
      legalLinkAccessibilityText: feed.legalAEMPath?.legalAccessibilityText || config.accessibilityTextLegal,
    };
    t.options = {
      variant: config?.variant,
      className: config?.margin && config.margin.join(" "),
      longLegalBtn: config?.longLegalBtn,
      btnSize: config?.btnSize,
      overrideColor: config?.color,
      fontType: config?.font,
      fontSize: config?.size,
      id: key,
      asStandalone: config?.asStandalone,
      dockedModalHeader: config?.dockedModalHeader,
    };

    if (t.data.legalLongText && !t.data.legalLinkText) {
      t.data.legalLinkText = "see details";
    }
    return t;
  }

  toProps(legalWrapperRuntimeProps?): LegalWrapperProps {
    const props = {
      key: this.key,
      data:
        legalWrapperRuntimeProps && legalWrapperRuntimeProps.onModalClose
          ? {
              ...this.data,
              onModalClose: legalWrapperRuntimeProps.onModalClose,
            }
          : this.data,
      options: this.options,
      margin: this.margin,
    };
    return props;
  }

  toJsx(legalWrapperRuntimeProps?): JSX.Element {
    return React.createElement(LegalWrapper, {
      ...this.toProps(legalWrapperRuntimeProps),
    });
  }
}
